import Icon from "@core-components/icon/Icon";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group } from "@mantine/core";
import GlobalGrade from "./GlobalGrade";

const ReviewHeadline = () => {
  const { t } = useAppTranslation("pages.reviews");

  return (
    <Group
      className="w-full justify-center max-md:text-center md:justify-between"
      align="center"
    >
      <SSHeadline
        props={{
          title: {
            size: 24,
          },
        }}
      >
        <Icon.Inbox size={26} />
        &nbsp;
        <SSWhiteText>{t("headline")}</SSWhiteText>
      </SSHeadline>
      <GlobalGrade />
    </Group>
  );
};

export default ReviewHeadline;
